import { render, staticRenderFns } from "./HairLongWant.vue?vue&type=template&id=415f89d9&scoped=true"
import script from "./HairLongWant.vue?vue&type=script&lang=js"
export * from "./HairLongWant.vue?vue&type=script&lang=js"
import style0 from "./HairLongWant.vue?vue&type=style&index=0&id=415f89d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f89d9",
  null
  
)

export default component.exports